import { createContext, useContext } from 'react'

export const AuthContext = createContext(null)

export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>')
  return ctx 
}

/** `{ can, permissions }` — see auth/permissions.js on what this actually enforces. */
export function usePermission() {
  const { can, permissions } = useAuth()
  return { can, permissions }
}
